import { useMemo, useState } from 'react'
import DevicePairingWizard from './DevicePairingWizard.jsx'

/**
 * OnboardingHero - Hero section for users with no devices
 * Shows Altion branding, feature highlights, and device pairing wizard
 */
function OnboardingHero() {
  const [showWizard, setShowWizard] = useState(false)
  
  const featureBadges = useMemo(() => [
    { icon: 'bi-speedometer2', text: 'Real-time Monitoring' },
    { icon: 'bi-gear-fill', text: 'Remote Configuration' },
    { icon: 'bi-bell-fill', text: 'Smart Alerts' },
  ], [])

  return (
    <div className="onboarding-hero-bg py-4">
      <div className="d-flex justify-content-center">
        <div className="card onboarding-card shadow-sm" style={{ maxWidth: '540px' }}>
          <div className="card-body text-center p-4">
            {/* Device icon container */}
            <div
              className="onboarding-icon-container mb-3"
              style={{
                width: '120px',
                height: '120px',
                margin: '0 auto',
                background: 'radial-gradient(circle at center, rgba(220,53,69,0.15), transparent)',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <img
                src="/images/Altion-final.svg"
                alt="Revatek Device"
                style={{ width: '80%', height: '80%' }}
              />
            </div>
            
            {/* Title and description */}
            <h1 className="display-6 fw-bold mb-2">Add Your First Altion</h1>
            <p className="text-muted mb-3">Unlock your power system&rsquo;s potential.</p>
            
            {/* Feature badges */}
            <div className="d-flex justify-content-center flex-wrap gap-2 mb-3">
              {featureBadges.map(({ icon, text }) => (
                <span key={text} className="badge bg-light text-dark border rounded-pill px-3 py-2">
                  <i className={`bi ${icon} me-1`} aria-hidden="true"></i>
                  {text}
                </span>
              ))}
            </div>
            
            {/* Add Device Button */}
            <button 
              className="btn btn-primary btn-lg px-4 shadow-lg"
              onClick={() => setShowWizard(true)}
            >
              <i className="bi bi-plus-circle me-2" aria-hidden="true"></i>
              Add Your First Device
            </button>
            
            {/* Help text */}
            <p className="text-muted small mt-3">
              <i className="bi bi-info-circle me-1"></i>
              Login to your Altion, enable Revatek Connect in the Configuration and enter the serial number found on the Device Info tab.
            </p>
          </div>
        </div>
      </div>
      
      {/* Device Pairing Wizard Modal */}
      {showWizard && (
        <DevicePairingWizard 
          isOpen={showWizard}
          onClose={() => setShowWizard(false)}
        />
      )}
    </div>
  )
}

export default OnboardingHero
